// Dòng nhắc vàng "ghi đủ ê-kíp" dưới khung gán ê-kíp (chấm QC bản 3, 4a) —
// dùng chung cho tab Ê-kíp của đơn và ô chi tiết lịch. Xem ekip-nudge.ts.
import { crewNudges } from "../ekip-nudge";

export function EkipCrewNudge({ order }: { order: Parameters<typeof crewNudges>[0] }) {
  const lines = crewNudges(order);
  if (lines.length === 0) return null;
  return (
    <div
      role="note"
      className="space-y-1 rounded-md border border-amber-300 bg-amber-50 p-2.5 text-xs leading-relaxed text-amber-800"
    >
      {lines.map((l) => (
        <p key={l}>⚠ {l}</p>
      ))}
    </div>
  );
}
